<template>
    <div class="person-visitors-filters d-flex flex-column flex-md-row justify-content-start justify-content-md-start align-items-stretch align-items-md-end">
        <app-form-text-input 
            label="Nombre"
            v-model="filter.name"
            @change="onChangeFilter"
            class="ml-2"
        />
        <app-form-text-input 
            label="Documento"
            v-model="filter.document"
            @change="onChangeFilter"
            class="ml-2"
        />
        <app-form-select-input 
            :options="validVisitorTypes"
            label="Tipo de Visitante"
            v-model="filter.visitorTypeId"
            @change="onChangeFilter"
            classes="ml-2"
        />
        <app-auto-complete
            type="structures"
            v-model="destination"
            label="Destino"
            id="destination"
            classes="ml-2"
            @change="onChangeFilter"
            :client-id="theClientId"
        />
        <app-form-select-input 
            :options="internalOptions"
            label="Interno / Externo"
            v-model="filter.internal"
            classes="ml-2"
            @change="onChangeFilter"
        />
        <app-date-picker 
            classes="ml-2"
            :with-time="false"
            label="Desde"
            v-model="filter.from"
            @change="onChangeFilter"
            id="from"
        />
        <app-date-picker 
            classes="ml-2"
            :with-time="false"
            label="Hasta"
            v-model="filter.to"
            @change="onChangeFilter"
            id="to"
        />
        <button class="btn btn-primary ml-2" @click="onFilter"><i class="fa fa-filter"></i> Filtrar</button>
        <button class="btn btn-secondary ml-2" @click="clearFilters"><i class="fa fa-trash-o"></i> Limpiar</button>
    </div>
</template>
<script>
    import DatePicker from '../../../UI/Controls/DateTimePicker/DateTimePicker.vue';
    import vigilanceRepository from '../../../../repositories/vigilance.repository';
    import AutoComplete from '../../../UI/Controls/Autocomplete/Autocomplete.vue';

    export default {
        components: {
            appDatePicker: DatePicker,
            appAutoComplete: AutoComplete            
        },
        props: {
            onFilter: {
                type: Function,
                required: true
            },
            clientId: {
                type: Number
            }
        },
        data(){
            return {
                visitorTypes: [],
                internalOptions: [
                    { id: 'I', name: 'Interno' },
                    { id: 'E', name: 'Externo' }
                ],
                filter: {
                    visitorTypeId: '',
                    from: '',
                    to: '',
                    internal: '',
                    destinationId: '',
                    name: '',
                    document: ''
                },
                destination: ''
            }
        },
        watch: {
            destination(newValue, oldValue) {
                !!newValue && (this.filter.destinationId = newValue.id);
            }
        },
        methods: {
            loadVisitorTypes(){
                const vr = Object.assign({}, vigilanceRepository);
                vr.getVisitorTypes()
                .then(data => this.visitorTypes = data)
                .catch(error => toastr.error('Ocurrió un error al cargar los tipos de visitante'));
            },
            onChangeFilter(){
                this.$emit('input', this.filter);
            },
            clearFilters(){
                Object.keys(this.filter).map(key => this.filter[key] = '');
                this.$bus.$emit('from.clear');
                this.$bus.$emit('to.clear');
                this.$bus.$emit('destination.reset');
                this.$emit('change', this.filter);
                this.onFilter();
            }
        },
        computed: {
            validVisitorTypes(){
                if(!this.visitorTypes) return [];
                return this.visitorTypes.filter(item => item.group === 'peatonal');
            },
            theClientId(){
                return ['super_admin', 'administrador', 'administrativo'].includes(this.user.profile.slug)? this.clientId: this.client.id;
            }
        },
        created(){
            this.loadVisitorTypes();
        }
    }
</script>